import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '库表域',
    type: 'DB_DA',
}
